(ns practitest.frontend.age-chart
  (:require [practitest.frontend.common.utils :as utils]
            [practitest.frontend.init :as init]
            [practitest.frontend.components2.dashboard.chart :refer [chart]]
            [clojure.string :as str]))

(defn root-view [{:keys [data-item-id data-edit-url data-warning]}]
  [chart #:chart{:id       (parse-long data-item-id)
                 :edit-url data-edit-url
                 :warning  (when (and (string? data-warning)
                                      (not (str/blank? data-warning)))
                             (js->clj (js/JSON.parse data-warning) :keywordize-keys true))}])

(defn ^:dev/after-load remount-roots []
  (init/remount-roots "age-chart-component" root-view))

(utils/register-webcomponent! "age-chart-component")
